import browser from './browser';

const vendorPrefix = () => {
  const prefix = {
    'ie11': '-ms-',
    'ie10': '-ms-',
    'chrome': '-webkit-',
    'opera': '-o-',
    'firefox': '-moz-',
    'safari': '-webkit-'
  };

  return prefix[browser()] || '';
};

export default vendorPrefix;



// WEBPACK FOOTER //
// ./node_modules/promokit-youtubeplayer/node_modules/promokit-util/src/vendorPrefix.js